var map = {
	"./img/AncientHistory.webp": 3349,
	"./img/Avatar.png": 4221,
	"./img/BCLHP.png": 2097,
	"./img/Blue-Aesthetic-Creative-PNG-Image.png": 3068,
	"./img/Blue-Aesthetic-PNG.png": 6778,
	"./img/Bunting-Map-of-the-World-around-Jerusalem-site-Keilo-Jack.jpg": 7867,
	"./img/ColdWar.jpg": 9601,
	"./img/Color-Explosion.png": 7407,
	"./img/Eitans-portfolio-page-picture.png": 73,
	"./img/Fugitives.jpg": 6622,
	"./img/Government.jpeg": 2732,
	"./img/HotTake.jpeg": 1264,
	"./img/Nerds.jpeg": 3619,
	"./img/Policing-in-America.png": 5409,
	"./img/Skype-a-Scientist.png": 2962,
	"./img/TLLogo.svg": 2818,
	"./img/The-Secret-Teacher.webp": 3518,
	"./img/berlin-wall.jpg": 1082,
	"./img/berlinWall.jpg": 234,
	"./img/black-death.avif": 4613,
	"./img/boozy-teacher.jpg": 4798,
	"./img/bpp.jpg": 7684,
	"./img/broken-pencil.png": 7488,
	"./img/chumash-indian-pow-wow.jpg": 6332,
	"./img/class-website-banner.png": 3837,
	"./img/conspiracyboard.webp": 5288,
	"./img/contact-button.png": 228,
	"./img/crumpled_paper.png": 9634,
	"./img/daphne-gomez.jpeg": 3164,
	"./img/diseases-image.jpg": 607,
	"./img/epics-banner.png": 1911,
	"./img/feral-circle.jpg": 3730,
	"./img/feral.png": 7022,
	"./img/film-banner.png": 8899,
	"./img/fist-with-pencil.png": 4990,
	"./img/flammarion-engraving.jpg": 2767,
	"./img/google-gemini-icon.png": 2134,
	"./img/greek-philosophers.webp": 8371,
	"./img/group_discussions.png": 6013,
	"./img/halo.png": 2318,
	"./img/hijab.png": 3278,
	"./img/hypnotizedArmy.png": 7744,
	"./img/kisspng-green-paint-brushes-watercolor-painting-light-7-light-green-watercolor-brush-stroke-png-transpa-5cfe874fbf4a88.1910132315601846557835.png": 204,
	"./img/leaf-wallpaper.png": 1666,
	"./img/light-bulb-vector-bg.jpg": 6252,
	"./img/logo.jpg": 701,
	"./img/logo.png": 9525,
	"./img/migration.jpg": 2508,
	"./img/mind-control-swirl1.webp": 7050,
	"./img/moms-spaghetti.webp": 249,
	"./img/money-vector-bg.jpg": 7112,
	"./img/na-bg.jpg": 8699,
	"./img/news.png": 859,
	"./img/paisleyOutline.png": 8271,
	"./img/paper-wallpaper.png": 9880,
	"./img/personal-finance.png": 1742,
	"./img/pirates.png": 37,
	"./img/png-transparent-brainwashing-mobile-app-development-youtube-mind-thought-fat-man-mobile-app-development-human-body-area-thumbnail.png": 74,
	"./img/programming-banner.png": 6647,
	"./img/progressive-democracy.png": 6067,
	"./img/r:AskHSteacher.png": 2348,
	"./img/rainbow-wallpaper.png": 3477,
	"./img/rantinghomer.gif": 4378,
	"./img/read-about-eitan-button.png": 5693,
	"./img/robot.jpg": 7178,
	"./img/saslogo.png": 6709,
	"./img/seamless-germs-virus-and-microbes-background-vector-16161805.webp": 7927,
	"./img/secretteacher.jpeg": 1594,
	"./img/statue-with-halo.jpg": 9272,
	"./img/stonehenge.png": 3099,
	"./img/students.png": 4787,
	"./img/survive-the-world-banner.png": 7017,
	"./img/tcc.png": 9509,
	"./img/teach-peoples-history.jpeg": 7399,
	"./img/tlLogo.jpeg": 7090,
	"./img/transparent-bg.png": 4198,
	"./img/triangle.svg": 2148,
	"./img/urges.jpeg": 8082,
	"./img/vapor-wave-statue.jpg": 7613,
	"./img/vaporwaveTrees.png": 1035,
	"./img/vaporwaveTrees1.png": 7386,
	"./img/vote.png": 9353,
	"./img/world-war-vctor-background.png": 5851,
	"./img/world-wars-banner.png": 7860,
	"./img/wp5004292-vaporwave-aesthetic-1920x1080-wallpapers.jpg": 6416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8159;